import { InvoiceTaxModel } from './invoicetax.model';

export class InvoiceLineModel {
    product: string;
    conceptUid: string;
    conceptCode: string;
    codigoTrazabilidad: string;
    quantity: number;
    discount: number;
    unityAmount: number;
    netPrice: number;
    taxes: Array<InvoiceTaxModel>;
    position: number;
    totalLine: number;

    constructor() {
        this.taxes = new Array<InvoiceTaxModel>();
        this.discount = 0;
        this.quantity = 1;
        this.unityAmount = 0;
    }
}
